module.exports = __webpack_public_path__ + "assets/img/typeD2a.32602d32.png";